module.exports = __webpack_public_path__ + "static/footer-krystufek-logo-c58868b6d9ec3c50bcc7a6ca74c4716a.svg";